<template>
  <div style="width: 100%; background-color: var(--grey_alpha)">
    <div class="view-content">
      <div class="component-container">
        <div
          v-if="false"
          v-bind:class="{
            'box-container-form': task.finished,
            'box-container': !task.finished,
          }"
        >
          <div class="content-container">
            <transition>
              <b-form-group>
                <b-button
                  class="btn-block filter-button"
                  @click="showFilters"
                  v-if="!show.filters"
                >
                  {{ $t("concordance.showfilters") }}
                </b-button>
                <b-button
                  class="btn-block filter-button"
                  @click="hideFilters"
                  v-if="show.filters"
                >
                  {{ $t("concordance.hidefilters") }}
                </b-button>
              </b-form-group>
            </transition>
            <b-form-group class="filters-grp">
              <TaskFilter
                :output="setFilters"
                v-show="show.filters"
                :visible="hideFilters"
                category="KONKORDANCJE"
              >
              </TaskFilter>
            </b-form-group>
            <b-button
              @click="startTask"
              class="btn-block submit-button"
              type="submit"
              variant="primary"
              v-if="!show.loading"
              >{{ $t("names_map.submit") }}
            </b-button>
            <b-button
              class="btn-block submit-button"
              disabled
              variant="primary"
              v-if="show.loading"
            >
              <b-spinner small type="grow" /><span v-if="task.finished">{{
                $t("task.loading_data")
              }}</span
              ><span v-if="!task.finished">{{
                $t("task.waiting_for_response")
              }}</span>
            </b-button>
          </div>
        </div>
        <div class="box-container-result" v-if="task.finished">
          <div class="content-container">
            <GeoNames />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import * as L from "leaflet";
import axios from "axios";
import "leaflet.markercluster";
import NamesMapPopup from "@/components/NamesMapPopup";
import TaskFilter from "@/components/TaskFilter";
import GeoNames from "@/components/GeoNames";

export default {
  name: "NamesMap",
  components: {
    NamesMapPopup,
    LMap,
    GeoNames,
    LTileLayer,
    LMarker,
    TaskFilter,
  },
  data() {
    return {
      task: {
        id: null,
        status: "",
        result: "",
        finished: true,
      },
      show: {
        loading: false,
        filters: false,
      },
      letter: "A",
      letters: [],
      coordinates: {
        A: [],
        Ą: [],
        B: [],
        C: [],
        Ć: [],
        D: [],
        E: [],
        Ę: [],
        F: [],
        G: [],
        H: [],
        I: [],
        J: [],
        K: [],
        L: [],
        Ł: [],
        M: [],
        N: [],
        Ń: [],
        O: [],
        Ó: [],
        P: [],
        R: [],
        S: [],
        Ś: [],
        T: [],
        U: [],
        W: [],
        Y: [],
        Z: [],
        Ź: [],
        Ż: [],
      },
      zoom: 13,
      default_size: 4,
      center: L.latLng(52.237049, 21.017532),
      url: "https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_nolabels/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      circle: {
        center: [52.237049, 21.017532],
        radius: 6,
        color: "red",
      },
      metadata_filters: [],
    };
  },
  mounted() {},
  computed: {
    map_data_table() {
      try {
        let newTable = this.coordinates[this.letter];
        return newTable;
      } catch (e) {
        console.log(Object.keys(e), e.message);
      }
    },
    filters_tagset() {
      return this.metadata_filters.map(function (x) {
        return x.name + ":" + x.value;
      });
    },
  },
  methods: {
    showFilters: function () {
      this.show.filters = false; //changed from true
    },
    hideFilters: function () {
      this.show.filters = false;
    },
    setFilters: function (metadata, all) {
      this.metadata_filters = [];
      for (let i = 0; i < all.length; i++) {
        if (
          typeof metadata[all[i]] !== "undefined" &&
          metadata[all[i]] !== ""
        ) {
          this.metadata_filters.push({
            name: all[i],
            value: metadata[all[i]],
          });
        }
      }
      if (
        typeof metadata["publication_year"] !== "undefined" &&
        metadata["publication_year"] !== ""
      ) {
        this.metadata_filters.push({
          name: "publication_year",
          value: metadata["publication_year"],
        });
      }
    },
    startTask: async function () {
      this.show.loading = true;
      this.coordinates = {};
      let task = {
        task_type: "geo_proper_names",
        metadata_filter: this.metadata_filters,
        query_parameters: [],
        response_parameters: [],
      };

      try {
        let response = await axios.post(
          process.env.ROOT_API + "startTask",
          task,
          {
            headers: {
              "Content-Type": "application/json",
            },
            timeout: 5000,
          }
        );
        this.task.id = response.data.id;
        this.checkStatus(this.task.id, 1000);
      } catch (e) {
        console.log(Object.keys(e), e.message);
      }
    },
    checkStatus: async function (taskId, timer) {
      try {
        timer += 200;
        let response = await axios.get(
          process.env.ROOT_API + "getStatus/" + taskId,
          {
            timeout: 10000,
          }
        );
        this.task.status = response.data.status;

        if (this.task.status === "DONE") {
          this.getResult(taskId);
        } else if (this.task.status === "QUEUE") {
          setTimeout(() => {
            this.checkStatus(taskId, timer);
          }, timer);
        }
      } catch (e) {
        console.log(Object.keys(e), e.message);
      }
    },
    getResult: async function (taskId) {
      try {
        let letters = new Set();
        let response = await axios.get(
          process.env.ROOT_API + "getResult/" + taskId,
          {
            timeout: 5000,
          }
        );
        this.points = response.data.result.rows;
        for (let i = 0; i < this.points.length; i++) {
          const { lon, lan, name, type, frequency } = this.points[i];
          const letter = name.charAt(0).toUpperCase() + "";
          for (var key in this.coordinates) {
            if (letter === key) {
              letters.add(key);

              const size = frequency > 100 ? 100 : frequency;
              this.coordinates[key].push({
                lanLon: [
                  parseFloat(lan.toPrecision(10)),
                  parseFloat(lon.toPrecision(10)),
                ],
                fullName: name,
                name: this.splitWords(name),
                type: type,
                frequency: frequency,
                icon: L.divIcon({
                  iconAnchor: [size / 2, size / 2],
                  labelAnchor: [size / 2, size / 2],
                  popupAnchor: [size / 2, size / 2],
                  iconSize: [size, size],
                  html: `<span style="${this.statePointIcon(frequency)}" />`,
                }),
              });
            }
          }
        }
        this.letters = Array.from(letters);
        this.letters.sort();
        this.letters.reverse();
        this.task.finished = true;
        this.show.loading = false;
      } catch (e) {
        console.log(Object.keys(e), e.message);
      }
    },
    splitWords(words) {
      let result = [];
      let s = words;
      s = s.replace(/(^\s*)|(\s*$)/gi, "");
      s = s.replace(/[ ]{2,}/gi, " ");
      s = s.replace(/\n /, "\n");
      result = s.split(" ");
      return result;
    },
    statePointIcon(frequency) {
      const size = frequency > 100 ? 50 : frequency;

      return `     background-color: rgb(0,0,0,0.3);
              width: ${size}px;
              height:${size}px;
              display: block;
              position: relative;
              border-radius: ${size}px ${size}px;`;
    },
    changeLetter(letter) {
      let prevButton = this.$refs["letter_" + this.letter][0];
      let nextButton = this.$refs["letter_" + letter][0];
      prevButton.classList.remove("active");
      nextButton.classList.add("active");
      this.letter = letter;
    },
  },
};
</script>

<style scoped>
.filter-button.active {
  background-color: var(--grey_dark1) !important;
}
</style>
<style>
.leaflet-marker-icon {
  width: 0;
  height: 0;
}

.leaflet-div-icon {
  border: inherit;
  background: none;
}
</style>



// WEBPACK FOOTER //
// src/views/NamesMap.vue